import { useController } from 'react-hook-form';

import ErrorMessage from '../ErrorMessage';
import Textarea from '../Textarea';
import Label from './Label';
import { parseMessage } from './utils';

function FormTextArea({
	name,
	label,
	id,
	control,
	disabled,
	required,
	errorMessageProps,
	...props
}) {
	const { field, fieldState } = useController({ name, control, disabled });

	return (
		<div className="relative w-full">
			{label && (
				<Label htmlFor={id}>{`${label}${required ? '*' : ''}`}</Label>
			)}
			<Textarea id={id} error={fieldState.invalid} {...field} {...props} />
			{fieldState.error?.message && (
				<ErrorMessage {...errorMessageProps}>
					{parseMessage(fieldState.error.message)}
				</ErrorMessage>
			)}
		</div>
	);
}

export default FormTextArea;
